import { createAction } from 'redux-dry-ts-actions';
export const referralActions = {
  getReferralData: createAction('GET_REFERRAL_DATA', campaignNanoid => ({
    campaignNanoid
  })),
  getReferralDataSuccess: createAction('GET_REFERRAL_DATA_SUCCESS', referral => referral),
  getReferralDataFailure: createAction('GET_REFERRAL_DATA_FAILURE', error => error)
};